export const getRandomInt = (to) => {
  to = Math.floor(to);
  return Math.floor(Math.random() * (to + 1));
};
